import { render, staticRenderFns } from "./BannerMtLinkModal.vue?vue&type=template&id=652fe3d4&"
import script from "./BannerMtLinkModal.vue?vue&type=script&lang=js&"
export * from "./BannerMtLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./BannerMtLinkModal.vue?vue&type=style&index=0&id=652fe3d4&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('652fe3d4')) {
      api.createRecord('652fe3d4', component.options)
    } else {
      api.reload('652fe3d4', component.options)
    }
    module.hot.accept("./BannerMtLinkModal.vue?vue&type=template&id=652fe3d4&", function () {
      api.rerender('652fe3d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/BannerMtLink/components/mobile/BannerMtLinkModal.vue"
export default component.exports